document.addEventListener("alpine:init", () => {
    Alpine.data("statisticsBanner", () => ({
        visible: false,
        init() {},
    }));
});
